<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>邀请好友配置</span>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="安卓" name="android">
            <el-form :inline="true" class="demo-form-inline">
              <el-row v-for="(item, index) in formData['android']" :key="index">
                <el-form-item label="区间ID">
                  <el-input v-model.number="item.section_id" readonly style="width: 100px;" placeholder="最小值" />
                </el-form-item>
                <el-form-item label="开始等级">
                  <el-input v-model.number="item.level" style="width: 100px;" placeholder="开始等级" />
                </el-form-item>
                <el-form-item label="游客奖励体力">
                  <el-input v-model.number="item.spins_guest" style="width: 100px;" placeholder="游客奖励体力" />
                </el-form-item>
                <el-form-item label="FB奖励体力">
                  <el-input v-model.number="item.spins_fb" style="width: 100px;" placeholder="FB奖励体力" />
                </el-form-item>
                <el-form-item label="绑定FB奖励体力">
                  <el-input v-model.number="item.bind_fb" style="width: 100px;" placeholder="绑定FB奖励体力" />
                </el-form-item>
              </el-row>
              <el-form-item>
                <el-button v-permisaction="['config:inviteReward:add']" type="primary" @click="save('android')">保存</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="IOS" name="ios">
            <el-form :inline="true" class="demo-form-inline">
              <el-row v-for="(item, index) in formData['ios']" :key="index">
                <el-form-item label="区间ID">
                  <el-input v-model.number="item.section_id" readonly style="width: 100px;" placeholder="区间ID" />
                </el-form-item>
                <el-form-item label="开始等级">
                  <el-input v-model.number="item.level" style="width: 100px;" placeholder="开始等级" />
                </el-form-item>
                <el-form-item label="游客奖励体力">
                  <el-input v-model.number="item.spins_guest" style="width: 100px;" placeholder="游客奖励体力" />
                </el-form-item>
                <el-form-item label="FB奖励体力">
                  <el-input v-model.number="item.spins_fb" style="width: 100px;" placeholder="FB奖励体力" />
                </el-form-item>
                <el-form-item label="绑定FB奖励体力">
                  <el-input v-model.number="item.bind_fb" style="width: 100px;" placeholder="绑定FB奖励体力" />
                </el-form-item>
              </el-row>
              <el-form-item>
                <el-button v-permisaction="['config:inviteReward:add']" type="primary" @click="save('ios')">保存</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>

        <!--        <div style="margin-top: 20px;margin-bottom: 15px;">-->
        <!--          <el-divider />-->
        <!--          <span>邀请进度奖励配置</span>-->
        <!--        </div>-->
        <!--        <el-form :inline="true" class="demo-form-inline">-->
        <!--          <el-row v-for="(item, index) in formData['process']" :key="index">-->
        <!--            <el-form-item label="进度">-->
        <!--              <el-input v-model.number="item.id" readonly style="width: 100px;" placeholder="进度" />-->
        <!--            </el-form-item>-->
        <!--            <el-form-item label="邀请人数">-->
        <!--              <el-input v-model.number="item.num" style="width: 100px;" placeholder="开始等级" />-->
        <!--            </el-form-item>-->
        <!--            <el-form-item label="奖励配置">-->
        <!--              <el-button type="primary" size="mini" icon="el-icon-edit" @click="visibleArr[index].visible = true" />-->
        <!--              <el-dialog :before-close="(d)=>{return handleClose(d, index)}" style="overflow-y: auto" title="奖励配置" width="750px" :visible="visibleArr[index].visible">-->
        <!--                <el-form>-->
        <!--                  <el-row v-for="(r,i) in item.reward.props" :key="i">-->
        <!--                    <el-form-item label="道具" style="margin-top: 10px;">-->
        <!--                      <el-select v-model.number="r.propsId" style="width: 130px;" placeholder="请选择">-->
        <!--                        <el-option-->
        <!--                          v-for="(item, index) in rewardType"-->
        <!--                          :key="index"-->
        <!--                          :label="item.label"-->
        <!--                          :value="item.value"-->
        <!--                        />-->
        <!--                      </el-select>-->
        <!--                    </el-form-item>-->
        <!--                    <el-form-item label="奖品数量" style="margin-top: 10px;">-->
        <!--                      <el-input v-model.number="r.num" style="width: 130px;" placeholder="奖品数量" />-->
        <!--                    </el-form-item>-->
        <!--                    <el-form-item style="margin-top: 10px;" label="金币取值">-->
        <!--                      <el-select v-model.number="r.rtype" :disabled="r.propsId !== 14" placeholder="请选择" style="width: 120px" :prop="'formData.'+index+'.config' +i +'.rtype'">-->
        <!--                        <el-option-->
        <!--                          v-for="item in selectType1"-->
        <!--                          :key="item.id"-->
        <!--                          :label="item.title"-->
        <!--                          :value="item.id"-->
        <!--                        />-->
        <!--                      </el-select>-->
        <!--                    </el-form-item>-->
        <!--                    <el-form-item style="margin-top: 10px;">-->
        <!--                      <el-button v-if="item.reward.length > 1" v-permisaction="['config:taskCfg:add']" type="danger" @click="removeReward(index, i)">删除</el-button>-->
        <!--                    </el-form-item>-->
        <!--                  </el-row>-->
        <!--                  <el-form-item style="margin-top: 10px">-->
        <!--                    <el-button type="primary" @click="addReward(index)">+</el-button>-->
        <!--                  </el-form-item>-->
        <!--                </el-form>-->
        <!--                <div slot="footer" class="dialog-footer">-->
        <!--                  <el-button @click="visibleArr[index].visible = false">取 消</el-button>-->
        <!--                  <el-button type="primary" @click="visibleArr[index].visible = false">确 定</el-button>-->
        <!--                </div>-->
        <!--              </el-dialog>-->
        <!--            </el-form-item>-->
        <!--            <el-form-item>-->
        <!--              <el-button v-permisaction="['config:inviteProcessReward:del']" type="danger" @click="delProcess(item.id)">删除</el-button>-->
        <!--            </el-form-item>-->
        <!--          </el-row>-->
        <!--          <el-form-item>-->
        <!--            <el-button v-permisaction="['config:inviteProcessReward:add']" type="primary" @click="addProcess()">+</el-button>-->
        <!--          </el-form-item>-->
        <!--          <el-form-item>-->
        <!--            <el-button v-permisaction="['config:inviteProcessReward:add']" type="primary" @click="saveProcess()">保存</el-button>-->
        <!--          </el-form-item>-->
        <!--        </el-form>-->
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import {
  delInviteprocessReward,
  getInviteprocessRewardList,
  getInviteRewardList,
  updateInviteProcessRewardCfg,
  updateInviteRewardlCfg
} from '@/api/config/invite-reward-cfg'
import { getRewardType } from '@/api/config/slot'
export default {
  name: 'InviteRewardConfig',
  data() {
    return {
      activeName: 'android',
      total: 0,
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      rewardType: [],
      cateType: [],
      selectType1: [
        {
          'id': 1,
          'title': '只取数量'
        },
        {
          'id': 2,
          'title': '等级取值'
        }
      ],
      selectType: [
        {
          'id': 1,
          'title': '金币'
        },
        {
          'id': 2,
          'title': '体力'
        },
        {
          'id': 3,
          'title': '卡片'
        },
        {
          'id': 4,
          'title': '星星'
        }
      ],
      options: [[]],
      visibleArr: [{ visible: false }],
      formData: {
        'android': [{
          'section_id': 0,
          'level': 0,
          'spins_guest': 0,
          'spins_fb': 0,
          'sid': 0,
          'bind_fb': 0
        }],
        'ios': [{
          'section_id': 0,
          'level': 0,
          'spins_guest': 0,
          'spins_fb': 0,
          'sid': 0,
          'bind_fb': 0
        }],
        'process': [{
          'id': 1,
          'num': 3,
          'reward': {
            'props': [{
              'propsId': 15,
              'rtype': 2,
              'num': 100,
              'skin': 0
            }]
          }
        }]
      }
    }
  },
  created() {
    this.getTables('android')
    this.getProcessTables()
    this.getRewardTypeData()
  },
  methods: {
    handleClose(d, index) {
      this.visibleArr[index].visible = false
    },
    save(name) {
      const data = JSON.stringify(this.formData[name])
      console.log(data)
      updateInviteRewardlCfg({ name: name, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables(name)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    saveProcess() {
      const data = JSON.stringify(this.formData['process'])
      console.log(data)
      updateInviteProcessRewardCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getProcessTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    onSubmit(name) {
      const data = JSON.stringify(this.formData[name])
      console.log(data)
      updateInviteRewardlCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables(name) {
      let sid = 1
      if (name === 'ios') {
        sid = 2
      }
      getInviteRewardList({ sid: sid }).then(res => {
        if (res.code === 200) {
          this.formData[name] = res.data
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getProcessTables() {
      getInviteprocessRewardList().then(res => {
        if (res.code === 200) {
          res.data.forEach((item, index) => {
            this.visibleArr.push({
              visible: false
            })
          })
          this.formData['process'] = res.data
        } else {
          this.msgError(res.msg)
        }
      })
    },
    handleClick(tab, event) {
      console.log(tab, event)
      this.getTables(tab.name)
    },
    addReward(index) {
      this.formData['process'][index].reward.props.push({
        'propsId': 15,
        'rtype': 2,
        'num': 100,
        'skin': 0
      })
    },
    removeReward(index, i) {
      this.formData['process'][index].reward.props = this.formData['process'][index].reward.props.filter((item, key) => {
        return key !== i
      })
    },
    delProcess(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delInviteprocessReward({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getProcessTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    addProcess() {
      const process = this.formData['process'].length
      this.formData['process'].push({
        'stage': process + 1,
        'num': 3,
        'reward': {
          'props': [
            {
              'propsId': 15,
              'rtype': 2,
              'num': 100,
              'skin': 0
            }
          ]
        }
      })
      this.visibleArr.push({
        visible: false
      })
    }
  }
}
</script>

<style scoped>
</style>
